<ion-content class="custom-content" [fullscreen]="true">


  <div style="display: flex; align-items: center; padding: 16px; gap: 10px; border-bottom: 1px solid #E4E0EB;">
     <ion-icon (click)="previousStep()" style="font-size: 25px; color: #1E1725; cursor: pointer"
       name="chevron-back-outline"></ion-icon>
     <div style="width: calc(100% - 70px); color: #1E1725; cursor: pointer; padding-top: 2px;" class="body-md-semibold">
       Your domains
     </div>
   </div>
 
   <div class="content-wrapper">
 
     <div style="display: flex; gap: 12px; padding: 20px; align-items: center; margin-bottom: 20px;">
       <div class="title-bold">
         Edit domain
       </div>
 
       <div
         style="border-radius: 20px; padding: 2px 12px; display: flex; justify-content: center; align-items: center; background-color: var(--green); color: white;">
         {{ domain }}
       </div>
 
     </div>
 
 
     <div class="nav-container">
       <button *ngFor="let tab of tabs" class="nav-tab" [class.active]="activeTab === tab" (click)="setActive(tab)">
         {{ tab }}
       </button>
     </div>
 
     <div *ngIf="isLoading === true" class="content" style="background-color: transparent; box-shadow: none;">
       <app-loading></app-loading>
     </div>
 
     <div style="padding: 20px; width: 100%;">
 
 
       <div *ngIf="isLoading === false && activeTab === 'Nameservers'"
         style="display: flex; width: 100%; margin: 12px 0; max-width: 1200px; justify-content: space-between; align-items: center;">
         <span class="body-large-bold" style="color: #202C4B;">Manage Nameserver</span>
       </div>
 
       <div *ngIf="isLoading === false && activeTab === 'Nameservers'" class="content">
 
         <div class="nameserver-card">
           <div class="setting-row">
             <div class="setting-info">
               <div class="body-sm-semibold" style="margin-bottom: 12px;">Use default nameservers</div>
               <div class="body-sm-medium">Automatically managed DNS with optimal performance</div>
             </div>
             <div [ngClass]="tempNameServerDetails['isDefault'] === true ? 'toggle-switch active' : 'toggle-switch'"
               id="defaultToggle" (click)="toggleDefault()">
               <div class="toggle-slider"></div>
             </div>
           </div>
 
          <div *ngIf="tempNameServerDetails['isDefault']" class="nameservers-list" id="defaultNameservers">
            <div class="body-sm-semibold">{{ getCurrentNameserverTitle() }} <span class="status-badge">Active</span></div>
            <div class="nameserver-item">
              <span class="nameserver-text"> kenia.ns.cloudflare.com </span>
            </div>
            <div class="nameserver-item">
              <span class="nameserver-text"> todd.ns.cloudflare.com </span>
            </div>
          </div>

          <div *ngIf="!tempNameServerDetails['isDefault']" class="custom-nameservers" id="customNameservers">
            <div class="section-header">
              <div>
                <div class="body-sm-semibold">{{ getCurrentNameserverTitle() }}</div>
                <div class="body-sm-regular section-description">Manage your custom nameserver provider details for this domain.</div>
              </div>
              <div *ngIf="!canEditCustomNameservers()" (click)="startEditingCustomNameservers()" class="secondary-button body-sm-medium">
                Edit
              </div>
            </div>

            <div *ngIf="hasDetectedCustomNameservers()" class="nameserver-alert">
              <div class="nameserver-alert-title body-sm-semibold">We detected that your nameservers have changed.</div>
              <div class="body-sm-regular nameserver-alert-text">
                This domain is now using custom nameservers, so DNS record management and forwarding management are no longer controlled here.
              </div>
              <div class="body-sm-regular nameserver-alert-text">
                Please manage your DNS records and forwarding settings directly with your current nameserver provider.
              </div>
            </div>

            <div *ngIf="!canEditCustomNameservers()" class="nameserver-readonly-list">
              <div *ngFor="let temp of tempNameServerDetails['nameservers']" class="nameserver-readonly-item">
                <span class="nameserver-text">{{ temp['name'] }}</span>
              </div>
            </div>

            <div *ngIf="canEditCustomNameservers()">
              <div class="body-sm-regular edit-hint">Update your nameservers below. Changes will only apply after you save.</div>

              <div id="customNameserversList">
                <div *ngFor="let temp of tempNameServerDetails['nameservers']; let i = index"
                  class="nameserver-input-group">
                  <app-input-field [validator]="validator?.['nameservers']?.[i]?.['name'] || {}"
                    [(ngModel)]="temp['name']" style="margin-bottom: 0; width: 100%;" placeholder="ns1.example.com">

                  </app-input-field>

                  <p-button (click)="removeNameserver(i)" icon="pi pi-trash" severity="danger" [rounded]="true"
                    [outlined]="true" />
                </div>
              </div>

              <div class="nameserver-edit-actions">
                <div (click)="addNameserver()" class="button body-sm-medium add-button">+ Add Nameserver</div>
              </div>
            </div>

          </div>
 
 
 
           <div *ngIf="shouldShowNameServerActions()" style="display: flex; gap: 12px; justify-content: flex-end;">
             <div class="button body-sm-medium" style="background-color: #E4E0EB; border: none; color: black;"
               (click)="handleNameServerCancel()">
               Cancel
             </div>
             <div *ngIf="shouldShowNameServerSaveButton()" (click)=" handleNameaServerSave()" class="button body-sm-medium">Save Changes
             </div>
 
           </div>
 
         </div>
 
 
       </div>
 
       <div *ngIf="isLoading === false && activeTab === 'Forwarding' && !hasDetectedCustomNameservers()"
         style="display: flex; width: 100%; margin: 12px 0; justify-content: space-between; align-items: center;">
         <span class="body-large-bold" style="color: #202C4B;">Domain</span>
         <div *ngIf="!hasDetectedCustomNameservers() && domainForwarding.length === 0" (click)="openForwardingManagement({}, false)" class="button">Add
           Forwarding</div>
       </div>

       <div *ngIf="isLoading === false && activeTab === 'Forwarding' && hasDetectedCustomNameservers()" class="management-alert">
         <div class="management-alert-title body-sm-semibold">{{ getExternalDnsWarningTitle() }}</div>
         <div class="body-sm-regular management-alert-text">{{ getExternalDnsWarningMessage() }}</div>
         <div class="body-sm-regular management-alert-text">{{ getExternalDnsWarningAction() }}</div>
       </div>
 
       <div *ngIf="isLoading === false && activeTab === 'Forwarding' && !hasDetectedCustomNameservers()" class="content"
         style="margin-bottom: 40px; min-height: fit-content; border: 1px solid #E9EDF4;">
 
         <p-table [columns]="forwardingCols" [resizableColumns]="true" columnResizeMode="expand" #dt [scrollable]="true"
           scrollHeight="flex" [value]="domainForwarding">
 
           <ng-template #header let-columns>
             <tr>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 30%;">
                 Domain
               </th>
 
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 50%;">
                 Destination
               </th>
 
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 10%;">
                 Status
               </th>
 
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 10%;">
                 Action
               </th>
 
 
             </tr>
 
           </ng-template>
 
           <ng-template #body let-forward let-rowIndex="rowIndex">
             <tr>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ forward.full_name }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ forward.destination_url }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ forward.status_code }}
               </td>
               <td>
                 <div *ngIf="!hasDetectedCustomNameservers()" style="display: flex; gap: 12px;">
                   <p-button (click)="openForwardingManagement(forward, false)" icon="pi pi-pencil" class="mr-2"
                     [rounded]="true" [outlined]="true" />
                   <p-button (click)="deleteForwarding(forward.ruleId, forward.subdomain)" icon="pi pi-trash"
                     severity="danger" [rounded]="true" [outlined]="true" />
                 </div>
               </td>
             </tr>
           </ng-template>
           <ng-template #emptymessage>
             <tr>
               <td class="body-sm-medium" colspan="8">No domain forwarding found.</td>
             </tr>
           </ng-template>
         </p-table>
 
 
 
       </div>
 
       <div *ngIf="isLoading === false && activeTab === 'Forwarding' && !hasDetectedCustomNameservers()"
         style="display: flex; width: 100%; margin: 12px 0; max-width: 1200px; justify-content: space-between; align-items: center;">
         <span class="body-large-bold" style="color: #202C4B;">Subdomains</span>
         <div *ngIf="!hasDetectedCustomNameservers()" (click)="openForwardingManagement({}, true)" class="button">Add Forwarding</div>
       </div>
 
       <div *ngIf="isLoading === false && activeTab === 'Forwarding' && !hasDetectedCustomNameservers()" class="content"
         style="min-height: fit-content; border: 1px solid #E9EDF4;">
 
         <p-table [columns]="subforwardingCols" [resizableColumns]="true" columnResizeMode="expand" #dt
           [scrollable]="true" scrollHeight="flex" [value]="subDomainForwarding">
 
           <!-- <ng-template #caption>
           
         </ng-template> -->
 
           <ng-template #header let-columns>
             <tr>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 30%;">
                 Subdomain
               </th>
 
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 50%;">
                 Destination
               </th>
 
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 10%;">
                 Status
               </th>
 
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: 10%;">
                 Action
               </th>
             </tr>
 
 
           </ng-template>
 
           <ng-template #body let-forward let-rowIndex="rowIndex">
             <tr>
 
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ forward.full_name }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ forward.destination_url }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ forward.status_code }}
               </td>
               <td>
                 <div *ngIf="!hasDetectedCustomNameservers()" style="display: flex; gap: 12px;">
                   <p-button (click)="openForwardingManagement(forward, true)" icon="pi pi-pencil" class="mr-2"
                     [rounded]="true" [outlined]="true" />
                   <p-button (click)="deleteForwarding(forward.ruleId, forward.subdomain)" icon="pi pi-trash"
                     severity="danger" [rounded]="true" [outlined]="true" />
                 </div>
               </td>
             </tr>
           </ng-template>
           <ng-template #emptymessage>
             <tr>
               <td class="body-sm-medium" colspan="8">No subdomain forwarding found.</td>
             </tr>
           </ng-template>
         </p-table>
 
 
       </div>
 
 
       <div *ngIf="isLoading === false && activeTab === 'DNS Records'"
         style="display: flex; width: 100%; margin: 12px 0; max-width: 1200px; justify-content: space-between; align-items: center;">
         <span class="body-large-bold" style="color: #202C4B;">Manage DNS</span>
 
         <div *ngIf="!hasDetectedCustomNameservers()" style="display: flex; gap: 8px;">
           <div (click)="openDnsManagement({type: 'A', data: {}}, '', true)" class="button">Add Records</div>
           <div *ngIf="showDeleteDnsButton()" (click)="deleteRecords(true, '')" class="button">Delete Records</div>
         </div>
       </div>

       <div *ngIf="isLoading === false && activeTab === 'DNS Records' && hasDetectedCustomNameservers()" class="management-alert">
         <div class="management-alert-title body-sm-semibold">{{ getExternalDnsWarningTitle() }}</div>
         <div class="body-sm-regular management-alert-text">{{ getExternalDnsWarningMessage() }}</div>
         <div class="body-sm-regular management-alert-text">{{ getExternalDnsWarningAction() }}</div>
       </div>
 
 
       <div *ngIf="isLoading === false && activeTab === 'DNS Records' && !hasDetectedCustomNameservers()" class="content"
         style="border: 1px solid #E9EDF4; height: fit-content;">
         <p-table [columns]="dnsCols" [resizableColumns]="true" columnResizeMode="expand" #dt [scrollable]="true"
           scrollHeight="flex" [value]="dns">
 
           <ng-template #header let-columns>
             <tr>
               <th *ngIf="!hasDetectedCustomNameservers()" class="table-header body-sm-semibold" style="width: 50px">
                 <app-checkbox-field [(ngModel)]="isSelectAll" (valueChange)="selectAllDns()"></app-checkbox-field>
               </th>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: calc((100% - 50px) / 5 * 2);">
                 Name
               </th>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: calc((100% - 50px) / 5 * 2);">
                 Type
               </th>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: calc((100% - 50px) / 5 * 2);">
                 TTL
               </th>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: calc((100% - 50px) / 5 * 3);">
                 Content
               </th>
               <th class="table-header body-sm-semibold" style="font-weight: 700; width: calc((100% - 50px) / 5 * 1);">
                 Action
               </th>
             </tr>
           </ng-template>
 
           <ng-template #body let-dns let-rowIndex="rowIndex">
             <tr>
               <td *ngIf="!hasDetectedCustomNameservers()">
                 <app-checkbox-field [items]="dns" field="selected" [(ngModel)]="dns['selected']"></app-checkbox-field>
               </td>
 
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ dns.name }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ dns.type }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ dns.ttl }}
               </td>
               <td style="font-size: 12px;" class="body-sm-semibold">
                 {{ dns.content }}
               </td>
               <td>
                 <div *ngIf="!hasDetectedCustomNameservers()" style="display: flex; gap: 12px;">
                   <p-button (click)="openDnsManagement(dns, dns['dns_id'], false)" icon="pi pi-pencil" class="mr-2"
                     [rounded]="true" [outlined]="true" />
                   <p-button (click)="deleteRecords(false, dns['dns_id'])" icon="pi pi-trash" severity="danger"
                     [rounded]="true" [outlined]="true" />
                 </div>
               </td>
             </tr>
           </ng-template>
           <ng-template #emptymessage>
             <tr>
               <td class="body-sm-medium" colspan="8">No dns records found.</td>
             </tr>
           </ng-template>
         </p-table>
       </div>
 
     </div>
 
 
 
   </div>
 
 
 </ion-content>
